import { useStyles } from './styles'

export const Glow = (props: React.CSSProperties) => {
  const { classes } = useStyles()
  return (
    <div
      style={props}
      className={classes.root}
    ></div>
  )
}
